<div class="page-container">
  <app-page-header
    title="Create Commercial Request"
    [showBackButton]="true"
    backRoute="/production-requests"
    backLabel="Back">
  </app-page-header>

  <div class="content-wrapper">
    <div class="form-card">
    @if (error) {
      <div class="error-message" role="alert">{{ error }}</div>
    }
    @if (successMessage) {
      <div class="success-message" role="status">{{ successMessage }}</div>
    }

    <form (ngSubmit)="submit()">
      <div class="form-section">
        <h3>Station &amp; details</h3>

        <app-coverage-city-select
          [multiple]="true"
          [required]="true"
          [stationCoverageOnly]="true"
          label="Coverage Cities"
          placeholder="Search and select cities"
          hint="Only cities with active station coverage are listed"
          [(ngModel)]="selectedCoverageCities"
          name="coverageCities"
          (citiesChange)="onCoverageCitiesChange($event)">
        </app-coverage-city-select>

        @if (selectedCoverageCities.length > 0) {
          @if (loadingStations) {
            <div class="inline-loading" role="status">
              <mat-spinner diameter="22"></mat-spinner>
              <span>Loading stations for selected cities…</span>
            </div>
          } @else if (stationsLoadError) {
            <div class="inline-error" role="alert">{{ stationsLoadError }}</div>
          } @else if (stations.length === 0) {
            <div class="inline-empty" role="status">No stations found for selected cities.</div>
          } @else {
            <app-station-select-field
              class="full-width"
              [stations]="stations"
              [(stationId)]="stationId"
              label="Station"
              placeholder="Search and select station"
              [required]="true" />
          }
        }

        <mat-form-field appearance="outline" class="full-width" subscriptSizing="dynamic">
          <mat-label>What does your business do?</mat-label>
          <textarea matInput [(ngModel)]="whatBusinessDoes" name="whatBusinessDoes" rows="4"
            placeholder="Describe your business in a few sentences..." required></textarea>
        </mat-form-field>

        <mat-form-field appearance="outline" class="full-width" subscriptSizing="dynamic">
          <mat-label>What's the goal of the campaign?</mat-label>
          <textarea matInput [(ngModel)]="campaignGoal" name="campaignGoal" rows="4"
            placeholder="What do you want to achieve with this commercial?" required></textarea>
        </mat-form-field>

        <mat-form-field appearance="outline" class="full-width" subscriptSizing="dynamic">
          <mat-label>What do you do that your competitors can't?</mat-label>
          <textarea matInput [(ngModel)]="uniqueSellingPoint" name="uniqueSellingPoint" rows="4"
            placeholder="Your unique selling point..." required></textarea>
        </mat-form-field>

        <mat-form-field appearance="outline" class="full-width" subscriptSizing="dynamic">
          <mat-label>What should listeners do after hearing this ad?</mat-label>
          <textarea matInput [(ngModel)]="callToAction" name="callToAction" rows="3"
            placeholder="Call a phone number, visit a website, visit a physical address, or follow on social media"></textarea>
          <mat-hint>Optional. Examples: call a phone number, visit a website, visit a store, or follow on social media.</mat-hint>
        </mat-form-field>

        <mat-form-field appearance="outline" class="full-width" subscriptSizing="dynamic">
          <mat-label>Duration (optional)</mat-label>
          <mat-select [(ngModel)]="duration" name="duration">
            @for (opt of durationOptions; track opt.value) {
              <mat-option [value]="opt.value">{{ opt.label }}</mat-option>
            }
          </mat-select>
        </mat-form-field>
      </div>

      <div class="actions">
        <button
          mat-raised-button
          color="primary"
          type="submit"
          class="submit-request-btn"
          [disabled]="submitting || loadingStations || !stationId || selectedCoverageCities.length === 0">
          @if (submitting) {
            <span class="submit-request-btn-content">
              <mat-spinner diameter="20" class="submit-spinner"></mat-spinner>
              <span class="submit-request-label">Submitting…</span>
            </span>
          } @else {
            Submit Request
          }
        </button>
        <a mat-stroked-button routerLink="/production-requests" class="cancel-action">Cancel</a>
      </div>
    </form>
    </div>
  </div>
</div>
